import { CONFIG } from 'config';

export const loadFonts = () => Promise.all([
  new FontFace('Mikado', `url(${CONFIG.MIKADO_BOLD_CDN})`, {
    style: 'normal',
    weight: '700',
  }).load()
    .then((result) => document.fonts.add(result))
    .catch((err) => console.log('Mikado bold', err)),
  new FontFace('Mikado', `url(${CONFIG.MIKADO_REGULAR_CDN})`, {
    style: 'normal',
    weight: '400',
  }).load()
  .then((result) => document.fonts.add(result))
  .catch((err) => console.log('Mikado regular', err))
]);